import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import uniq from 'lodash/uniq';
import DateSelect from 'components/DateSelect';

const ProcessStartDateSelect = props => {
  const {
    isValid = true,
    label,
    required,
    controlFunc,
    touchFunc,
    name,
    values,
    preDefinedValues,
  } = props;

  const currentYear = useMemo(() => new Date().getFullYear(), []);
  const currentMonth = useMemo(() => new Date().getMonth(), []);

  const monthOptions = useMemo(() => {
    const result = [];

    if (preDefinedValues.year <= currentYear && values.year <= currentYear) {
      result.push(preDefinedValues.month);
    }

    if (preDefinedValues.year === currentYear || values.year === currentYear) {
      for (let month = currentMonth; month < 12; ++month) {
        result.push(month + 1);
      }
      uniq(result.sort((a, b) => a - b));
    }

    return result.length > 0 ? result : null;
  }, [preDefinedValues, values]);

  const yearOptions = useMemo(() => {
    const result = [];
    if (preDefinedValues.year < currentYear) {
      result.push({
        value: preDefinedValues.year,
        label: preDefinedValues.year,
      });
    }
    for (let year = currentYear; year < currentYear + 6; ++year) {
      result.push({
        value: year,
        label: year,
      });
      result.sort((a, b) => Number(a) - Number(b));
    }
    return result;
  }, [preDefinedValues]);

  const handleOnChange = (name, { month = null, year = null }) => {
    let updatedMonth = month;
    if (preDefinedValues.month && preDefinedValues.year) {
      if (year === currentYear) {
        updatedMonth = month < currentMonth ? preDefinedValues.month : month;
      } else if (year < currentYear) {
        updatedMonth = preDefinedValues.month;
      }
    }

    controlFunc(name, { month: updatedMonth, year });
  };

  return (
    <DateSelect
      required={required}
      label={label}
      name={name}
      controlFunc={handleOnChange}
      touchFunc={touchFunc}
      yearOptions={yearOptions}
      monthOptions={monthOptions}
      values={values}
      isValid={isValid}
    />
  );
};

ProcessStartDateSelect.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  isValid: PropTypes.bool,
  yearOptions: PropTypes.array,
  values: PropTypes.shape({
    month: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  preDefinedValues: PropTypes.shape({
    month: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  controlFunc: PropTypes.func.isRequired,
  touchFunc: PropTypes.func,
};

export default ProcessStartDateSelect;
